import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillOfQuantitiesLogicService } from './logic/bill-of-quantities/bill-of-quantities-logic.service';
import { BillOfQuantitiesDaoService } from './dao/bill-of-quantities-dao.service';
import { BillOfQuantitiesStorageDaoService } from './dao/bill-of-quantities-dao/bill-of-quantities-storage-dao.service';
import { BillOfQuantitiesService } from './logic/bill-of-quantities.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: BillOfQuantitiesService, useClass: BillOfQuantitiesLogicService },
    {
      provide: BillOfQuantitiesDaoService,
      useClass: BillOfQuantitiesStorageDaoService
    }
  ]
})
export class BillOfQuantitiesModule {}
